const state = {
  reportArchive: { data: [], meta: null },
};
const mutations = {
  SET_REPORT_ARCHIVE(state, payload) {
    state.reportArchive = payload && payload.data ? payload : { data: [], meta: null };
  },
};
const getters = {
  getReportArchive: (state) => state.reportArchive,
};

export default {
  state,
  mutations,
  getters,
};
